<template>
  <expandable-material-card
    :title="$t('components.portal.plan_notifications')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="notifications"
  >
    <v-card-text>
      <pbas-data-table
        ref="table"
        :showSelect="false"
        :dataProvider="provider"
        :rowActions="rowActions"
        :floatActions="floatActions"
        fileNamePrefix="plan-notifications"
        identifier="plan_notifications"
        @error="error = $event"
      ></pbas-data-table>
    </v-card-text>

    <v-dialog scrollable v-model="deleteDialog" persistent max-width="400">
      <material-card
        v-if="editedItem"
        :title="$t('components.portal.plan_notifications.delete')"
        :color="$vuetify.theme.themes.light.error"
        icon="delete"
      >
        <v-card-text>
          {{ $t("globals.are_you_sure") }}
        </v-card-text>
        <v-card-actions>
          <v-btn color text @click="deleteDialog = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="error" text @click="tryDelete">
            {{ $t("globals.delete") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog scrollable v-model="editDialog" persistent max-width="1200px">
      <material-card
        v-if="editedItem !== null && editedItem !== undefined"
        :title="formTitle"
        :icon="formIcon"
        :color="formColor"
      >
        <v-card-text>
          <v-form ref="form" v-model="valid">
            <v-container fill-height fluid>
              <v-row wrap>
                <div class="col-12 col-xs-12 col-sm-6 col-md-4">
                  <no-autocomplete-textfield
                    v-model="editedItem.Id"
                    :label="$t('headers.memberdependants.id')"
                    class="required"
                    :rules="[$rules.required]"
                    disabled
                  ></no-autocomplete-textfield>
                </div>
                <div class="col-12 col-xs-12 col-sm-6 col-md-2">
                  <v-select
                    v-model="editedItem.Category"
                    :label="$t('globals.category')"
                    class="required"
                    :rules="[$rules.required]"
                    :items="planNotificationCategories"
                  ></v-select>
                </div>
                <div class="col-12 col-xs-12 col-sm-6 col-md-2">
                  <v-select
                    v-model="editedItem.Type"
                    :label="$t('globals.type')"
                    :items="planNotificationTypes"
                  ></v-select>
                </div>

                <template v-if="editedItem.Type === 'start-end-date'">
                  <div class="col-12 col-xs-12 col-sm-6 col-md-2">
                    <pbas-date-picker
                      :label="$t('headers.plan_notifications.start_date')"
                      :value="editedItem.StartDate"
                      @update-date="editedItem.StartDate = $event"
                      :rules="[$rules.required]"
                      class="required"
                    ></pbas-date-picker>
                  </div>
                  <div class="col-12 col-xs-12 col-sm-6 col-md-2">
                    <pbas-date-picker
                      :label="$t('headers.plan_notifications.end_date')"
                      :value="editedItem.EndDate"
                      @update-date="editedItem.EndDate = $event"
                      :rules="[$rules.required]"
                      class="required"
                    ></pbas-date-picker>
                  </div>
                </template>

                <template v-for="lang in languages">
                  <div
                    class="col-12 col-xs-12 col-sm-6"
                    :key="`title${lang.language}`"
                  >
                    <v-flex md12>
                      <no-autocomplete-textfield
                        v-model="
                        editedItem[`Title${$helpers.toPascalCase(lang.language)}`]
                      "
                        :label="
                        $t(`headers.plan_notifications.title_{0}`, [
                          lang.language.toUpperCase(),
                        ])
                      "
                        :rules="
                        $helpers.isRequired(lang.language, selectedLanguages)
                          ? [$rules.required]
                          : []
                      "
                        :class="
                        $helpers.isRequired(lang.language, selectedLanguages) ? 'required' : ''
                      "
                        :clearable="!$helpers.isRequired(lang.language, selectedLanguages)"
                      ></no-autocomplete-textfield>
                    </v-flex>
                  </div>
                  <div
                    class="col-12 col-xs-12 col-sm-6"
                    :key="`text${lang.language}`"
                  >
                    <v-flex md12 :key="`text${lang.language}`">
                      <v-textarea
                        v-model="
                        editedItem[`Text${$helpers.toPascalCase(lang.language)}`]
                      "
                        :label="
                        $t(`headers.plan_notifications.text_{0}`, [
                          lang.language.toUpperCase(),
                        ])
                      "
                        :rules="
                        $helpers.isRequired(lang.language, selectedLanguages)
                          ? [$rules.required]
                          : []
                      "
                        :class="
                        $helpers.isRequired(lang.language, selectedLanguages) ? 'required' : ''
                      "
                        :clearable="!$helpers.isRequired(lang.language, selectedLanguages)"
                        rows="1"
                        auto-grow
                      ></v-textarea>
                    </v-flex>
                  </div>
                </template>
                <!-- <div class="col-12 col-xs-12 col-sm-6 col-md-4">
                  <v-textarea
                    v-model="editedItem.Text"
                    :label="$t('components.portal.theme.left_drawer.text')"
                    class="required"
                    :rules="[$rules.required]"
                    :rows="1"
                    auto-grow
                  ></v-textarea>
                </div> -->
                <div class="col-12 col-xs-12 col-sm-6 col-md-4">
                  <v-combobox
                    :value="memberTypes.split(',').filter((e) => e)"
                    @input="memberTypes = $event.filter((e) => e).join(',')"
                    hide-selected
                    :label="$t('globals.member_groups')"
                    :hide-no-data="!inputMemberType"
                    :search-input.sync="inputMemberType"
                    multiple
                    small-chips
                    :rules="[rules.requiredStr]"
                    class="required"
                  >
                    <template
                      v-slot:selection="{ attrs, item, parent, selected }"
                    >
                      <v-chip
                        v-bind="attrs"
                        color="primary"
                        :input-value="selected"
                        label
                        small
                      >
                        <span class="pr-2">
                          {{ item }}
                        </span>
                        <v-icon small @click="parent.selectItem(item)">
                          close
                        </v-icon>
                      </v-chip>
                    </template>
                  </v-combobox>
                </div>
                <div class="col-12 col-xs-12 col-sm-6 col-md-4">
                  <mdi-icons-dropdown
                    :value.sync="editedItem.Icon"
                    :label="$t('views.downloadcenter.icon')"
                    class="required"
                    :rules="[$rules.required]"
                  ></mdi-icons-dropdown>
                </div>
                <div class="col-12 col-xs-12 col-sm-6 col-lg-4">
                  <color-selector
                    :value.sync="editedItem.Color"
                    :rules="[$rules.required]"
                    class="required"
                    :systemColors="systemColors"
                    :label="$t('globals.color')"
                    :hexColorsOnly="true"
                  />
                </div>
                <div class="col-12 col-xs-12 col-sm-6 col-md-4">
                  <v-select
                    v-model="editedItem.Status"
                    :label="$t('headers.members_wizard.Status')"
                    class="required"
                    :rules="[$rules.required]"
                    :items="planNotificationStatus"
                  ></v-select>
                </div>
                <div class="col-12 col-xs-12 col-sm-6 col-md-4">
                  <pbas-date-picker
                    :label="$t('headers.plan_notifications.date_uploaded')"
                    :value="editedItem.DateCreated"
                    @update-date="editedItem.DateCreated = $event"
                    :rules="[$rules.required]"
                    class="required"
                    disabled
                  ></pbas-date-picker>
                </div>
                <div class="col-12 col-xs-12 col-sm-6 col-md-4">
                  <pbas-date-picker
                    :label="$t('headers.plan_notifications.date_read')"
                    :value="editedItem.DateRead"
                    @update-date="editedItem.DateRead = $event"
                    disabled
                  ></pbas-date-picker>
                </div>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="close">{{ $t("globals.cancel") }}</v-btn>
          <v-btn :disabled="!valid" color="primary" @click="save">
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <error-handler :error="error"></error-handler>
  </expandable-material-card>
</template>

<script>
import { mapGetters } from "vuex";
import ErrorHandler from "@/components/ErrorHandler";
import NoAutocompleteTextfield from "@/components/NoAutocompleteTextfield";
import { InMemoryProvider } from "pbas-vue-components";
import getHeaders from "@/headers/PlanNotifications";
import MdiIconsDropdown from "./MdiIconsDropdown.vue";
import ColorSelector from "./ColorSelector.vue";
import ExpandableMaterialCard from "./ExpandableMaterialCard.vue";

export default {
  props: ["items", "systemColors"],
  components: {
    ErrorHandler,
    NoAutocompleteTextfield,
    MdiIconsDropdown,
    ColorSelector,
    ExpandableMaterialCard,
  },
  data() {
    return {
      error: null,
      deleteDialog: false,
      floatActions: [
        {
          name: "addItem",
          icon: "add",
          color: "#64ba5f",
          text: "globals.add_new",
          handler: () => {
            let now = new Date();
            let day = now.getDate();
            let month = now.getMonth() + 1;
            if (day.toString().length === 1) day = "0" + day.toString();
            if (month.toString().length === 1) month = "0" + month.toString();

            let item = {
              DateCreated:
                now.getFullYear() + "-" + month + "-" + day + "T00:00:00.000Z",
              Id: this.$helpers.uuidv4(),
            };
            this.isNew = true;
            this.editItem(item);
          },
        },
      ],
      rowActions: [
        {
          name: "edit",
          icon: "edit",
          title: "globals.edit",
          handler: (item) => {
            this.isNew = false;
            this.editItem(item);
          },
        },
        {
          name: "delete",
          icon: "delete",
          title: "globals.delete",
          handler: (item) => {
            this.editedItem = item;
            this.deleteDialog = true;
          },
        },
      ],
      editDialog: false,
      valid: true,
      editedItem: null,
      isNew: false,
      provider: undefined,
      planNotificationCategories: ["Dashboard", "Claim", "Popup"],
      planNotificationTypes: ["", "confirm address", "show-once", "start-end-date", "add-beneficiary"],
      planNotificationStatus: ["Permanent", "Popup"],
      memberTypes: "",
      inputMemberType: "",
      rules: {
        requiredStr: (v) => {
          console.log(v);
          return v.length > 0 || this.$t("validation.required");
        },
      },
    };
  },
  computed: {
    ...mapGetters("common", ["language", "languages"]),
    ...mapGetters("plansMembers", ["options"]),
    formTitle() {
      return this.isNew
        ? this.$t("components.portal.plan_notifications.add")
        : this.$t("components.portal.plan_notifications.edit");
    },
    formIcon() {
      return this.isNew ? "add" : "edit";
    },
    formColor() {
      return this.isNew ? this.$vuetify.theme.themes.light.success : this.$vuetify.theme.themes.light.primary;
    },
  },
  watch: {
    items: {
      handler() {
        this.loadPlanData();
      },
    },
    systemColors: {
      handler() {
        this.loadPlanData();
      },
    },
  },
  mounted() {
    this.loadPlanData();
  },
  methods: {
    updateItems(items) {
      this.$nextTick(() => {
        this.$emit("update", items);
      });
    },
    loadPlanData() {
      this.$nextTick(()=>{
        let items = [];
        if (this.items !== null && this.items !== undefined) {
          items = this.items.map((o) => {
            o.Identifier = Math.random().toString();
            return o;
          });
        }
        this.provider = new InMemoryProvider(
          items,
          getHeaders(this.languages, this.systemColors)
        );
        if (this.$refs.table) {
          this.$refs.table.getDataAsync();
          this.$forceUpdate();
        }
      });
    },
    async editItem(item) {
      this.editedItem = JSON.parse(JSON.stringify(item));
      if (this.editedItem.MemberTypes!=null && this.editedItem.MemberTypes!==undefined) {
        this.memberTypes = JSON.stringify(this.editedItem.MemberTypes)
        .replace(/\[/g, "")
        .replace(/\]/g, "")
        .replace(/"/g, "");
      } else {
        this.memberTypes = "";
      }
      this.editDialog = true;
    },
    close() {
      this.editDialog = false;
      this.editedItem = null;
      this.$refs.form.resetValidation();
    },
    save() {
      this.editedItem.PlanIdentityId = this.planIdentityId;
      this.editedItem.MemberTypes = this.memberTypes.split(",");
      if (this.isNew) {
        this.add();
      } else {
        this.update();
      }
    },
    async update() {
      const item = this.provider.items.filter(
        (o) => o.Identifier === this.editedItem.Identifier
      )[0];
      const index = this.provider.items.indexOf(item);
      this.provider.items[index] = JSON.parse(JSON.stringify(this.editedItem));
      this.close();
      this.$refs.table.getDataAsync();
      this.updateItems(this.provider.items);
    },
    async add() {
      this.provider.items.push(JSON.parse(JSON.stringify(this.editedItem)));
      this.close();
      this.$refs.table.getDataAsync();
      this.updateItems(this.provider.items);
    },
    async tryDelete() {
      const item = this.provider.items.filter(
        (o) => o.Identifier === this.editedItem.Identifier
      )[0];
      const index = this.provider.items.indexOf(item);
      this.provider.items.splice(index, 1);
      this.deleteDialog = false;
      this.$refs.table.getDataAsync();
      this.updateItems(this.provider.items);
    },
  },
};
</script>
